const items = [
    "وصول خلال ١٥–٣٠ دقيقة",
    "فتح أبواب بدون إتلاف",
    "برمجة جميع مفاتيح السيارات",
    "خدمة 24 ساعة · 7 أيام",
    "تغطية كل أحياء جدة",
    "أسعار واضحة قبل البدء",
];

const Marquee = () => {
    const row = [...items, ...items];
    return (
        <div
            data-testid="marquee"
            className="relative overflow-hidden border-y border-white/5 bg-[#121824] py-5"
            dir="ltr"
        >
            <div className="animate-marquee flex w-max items-center gap-10">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center gap-10">
                        {row.map((item, i) => (
                            <span
                                key={`${half}-${i}`}
                                className="flex items-center gap-10 whitespace-nowrap"
                            >
                                <span className="font-display text-lg font-bold text-gray-400">
                                    {item}
                                </span>
                                <span className="text-amber-500">✦</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Marquee;
